import {all, call, put, takeEvery} from 'redux-saga/effects';
import {
  DraftsPeopleActionTypes,
  fetchError,
  fetchSuccess,
  updateSuccess,
  updateError
} from '@actions/draftPeople';
import draftPeopleApi from '@api/draftPeople'
import {ReduxAction} from "@actions/index";

function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(draftPeopleApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err.stack!))
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(draftPeopleApi.update, payload);
    yield put(updateSuccess(data))
  } catch (err) {
    yield put(updateError(err));
  }
}

// We can also use `fork()` here to split our saga into multiple watchers.
function* draftsPeopleSaga() {
  yield all([
    yield takeEvery(DraftsPeopleActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(DraftsPeopleActionTypes.UPDATE_REQUEST, handleUpdate),
  ])
}

export default draftsPeopleSaga;
